import React from 'react';
import MainButton from '@/components/UI/mobile/MainButton';
import { Box } from '@mui/material';

const Footer: React.FC<{
  onOk: () => void;
  onCancel: () => void;
  showOk: boolean;
}> = ({ onOk, onCancel, showOk }) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: showOk ? '1fr 1fr' : 'auto',
          columnGap: '1rem',
        }}
      >
        <MainButton onClick={onCancel}>{showOk ? '取消' : '關閉'}</MainButton>
        {showOk && <MainButton onClick={onOk}>送出</MainButton>}
      </Box>
    </Box>
  );
};

export default Footer;
